module.exports = __webpack_public_path__ + "img/黄侃.c1f7ec5c.jpg";